import modules from '@i18n-message-modules'

export function createMessages(locales) {
  return locales.reduce((acc, locale) => {
    acc[locale] = modules.reduce((messages, module) => {
      Object.assign(messages, module[locale] || {})
      return messages
    }, {})
    return acc
  }, {})
}
